import { render, staticRenderFns } from "./ReferedStudentsList.vue?vue&type=template&id=24bbc8fa&scoped=true&"
import script from "./ReferedStudentsList.vue?vue&type=script&lang=js&"
export * from "./ReferedStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./ReferedStudentsList.vue?vue&type=style&index=0&id=24bbc8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbc8fa",
  null
  
)

export default component.exports